import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const BatchLinkCard = ({ routine }) => {
  return (
    <div className="container-fluid p-0">
      <Card
        sx={{
          display: "flex",
          justifyContent: "space-around",
          textAlign: "center",
          height: "13vh",
        }}
      >
        <Link
          to={routine?.Link}
          style={{ textDecoration: "none", color: "#fff" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CardContent sx={{ flex: "1 0 auto" }}>
              <Typography component="div" variant="h6">
                {routine.BatchTitle}
              </Typography>
            </CardContent>
          </Box>
        </Link>
      </Card>
    </div>
  );
};

export default BatchLinkCard;
